import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, RequireAuth } from "@/admin/AuthContext";
import PreviewHub from "@/pages/PreviewHub";
import RespondentIntro from "@/pages/RespondentIntro";
import SurveyQuestion from "@/pages/SurveyQuestion";
import AdminDashboard from "@/pages/AdminDashboard";
import RespondentLink from "@/pages/RespondentLink";
import Login from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Organizations from "@/pages/admin/Organizations";
import Waves from "@/pages/admin/Waves";
import Consents from "@/pages/admin/Consents";
import Invitations from "@/pages/admin/Invitations";
import Monitoring from "@/pages/admin/Monitoring";
import Exports from "@/pages/admin/Exports";
import Instruments from "@/pages/admin/Instruments";
import InstrumentEditor from "@/pages/admin/InstrumentEditor";
import InstrumentPreview from "@/pages/admin/InstrumentPreview";
import RespondentPreview from "@/pages/admin/RespondentPreview";
import Audit from "@/pages/admin/Audit";
import Team from "@/pages/admin/Team";
import Landing from "@/landing/Landing";

function AppRouter() {
  return (
    <Routes>
      {/* Public landing (survey.comiq.id) */}
      <Route path="/" element={<Landing />} />

      {/* Design-system previews (approved) */}
      <Route path="/preview" element={<PreviewHub />} />
      <Route path="/preview/intro" element={<RespondentIntro />} />
      <Route path="/preview/question" element={<SurveyQuestion />} />
      <Route path="/preview/admin" element={<AdminDashboard />} />

      {/* Respondent magic link */}
      <Route path="/s/:token" element={<RespondentLink />} />

      {/* Admin */}
      <Route path="/admin/login" element={<Login />} />
      <Route
        path="/admin"
        element={
          <RequireAuth>
            <AdminLayout />
          </RequireAuth>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="organizations" element={<Organizations />} />
        <Route path="waves" element={<Waves />} />
        <Route path="consents" element={<Consents />} />
        <Route path="instruments" element={<Instruments />} />
        <Route path="instruments/:versionId" element={<InstrumentEditor />} />
        <Route path="instruments/:versionId/preview" element={<InstrumentPreview />} />
        <Route path="instruments/:versionId/respondent-view" element={<RespondentPreview />} />
        <Route path="invitations" element={<Invitations />} />
        <Route path="monitoring" element={<Monitoring />} />
        <Route path="exports" element={<Exports />} />
        <Route path="audit" element={<Audit />} />
        <Route
          path="team"
          element={
            <RequireAuth roles={["platform_admin"]}>
              <Team />
            </RequireAuth>
          }
        />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
